import React from 'react';
import { Route } from 'react-router-dom';
import Routes from './routes';
import CreerCompte from './creer';
import RecupererLogin from './recuperer-login';
import { getPath } from '../../utils/router';

const Compte = () => {
    return (
        <>
            <Route
                path={getPath(Routes.subroutes.creer)}
                render={(subProps) => <CreerCompte {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.recupererLogin)}
                render={(subProps) => <RecupererLogin {...subProps} />}
            />
        </>
    );
};

export default Compte;
